<div *ngIf="siteConfig && sections.length > 0">
  <section-renderer
    [isServerSideRendering]="false"
    [sections]="sections"
    [globalStyles]="siteConfig.globalStyles"
    [pageType]="pageType"
    (textAndMediaOnCallToActionPageClickedEvent)="textAndMediaOnCallToActionPageClicked($event)">
  </section-renderer>
</div>
